import { render, staticRenderFns } from "./allergySetupList.vue?vue&type=template&id=005dee18&"
import script from "./allergySetupList.vue?vue&type=script&lang=js&"
export * from "./allergySetupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports